import Splide from '@splidejs/splide';

const sliders = document.querySelectorAll('.splide');

sliders.forEach((slider) => {
  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 2,
    perMove: 1,
    gap: 32,
    pagination: false,
    arrows: true,
    breakpoints: {
      991: {
        perPage: 1,
      },
    },
  });

  const progressBar = splide.root.querySelector('.progress .progress-bar');

  // Updates the bar width whenever the carousel moves:
  splide.on('mounted move', () => {
    const end = splide.Components.Controller.getEnd() + splide.options.perPage;
    const rate = Math.min((splide.index + splide.options.perPage) / end, 1);

    if (progressBar) {
      progressBar.style.width = `${String(100 * rate)}%`;
    }
  });

  splide.mount();
});
